import * as j from '@mojotech/json-type-validation';

export interface DiallerGroupAccessFilterDict {
  [key: string]: number[];
}

export const DiallerGroupByAccessFilterResponseDecoder: j.Decoder<DiallerGroupAccessFilterDict> = j.dict(
  j.array(j.number()),
);
